module.exports = __webpack_public_path__ + "img/blue-btn.2a93cd09.svg";